import api, { unwrap } from './client';

/* Versions de plan (2026-09-27) : la liste que lit le sélecteur de la barre,
   et les gestes réservés à l'administrateur et au financier du client. */

export const listPlanVersions = (tenantId) =>
  unwrap(api.get(`/plan-versions/${tenantId}`));

export const createPlanVersion = (tenantId, payload) =>
  unwrap(api.post(`/plan-versions/${tenantId}`, payload));

export const patchPlanVersion = (tenantId, versionId, payload) =>
  unwrap(api.patch(`/plan-versions/${tenantId}/${versionId}`, payload));

export const deletePlanVersion = (tenantId, versionId) =>
  unwrap(api.delete(`/plan-versions/${tenantId}/${versionId}`));
